import { Button, Form, Modal, notification, Select } from 'antd';
import { useOvertimeTakeToWorkMutation } from 'app/services/edpApiV1/overtime';
import React, { useState } from 'react';
import { RolesUser } from 'shared/enums';
import { RolesToRussian } from 'shared/enums/rolesUser';
import { returnErrorOrMessage } from 'shared/helpers/errors';
import { TOvertimeTakeToWorkRequest } from 'shared/types/overtime.types';

type TProps = {
  openModal: boolean;
  setOpenModal: React.Dispatch<React.SetStateAction<boolean>>;
  allSubordinates: {
    id: number;
    lastName: string | null;
    middleName: string | null;
    name: string | null;
    organizationId: string | null;
    roleName: string | null;
  }[];
  requestId: number;
  vacationHrId?: number | null;
};

const ModalChangeResponsible = ({ allSubordinates, openModal, setOpenModal, requestId, vacationHrId }: TProps) => {
  const [trigger, result] = useOvertimeTakeToWorkMutation();
  const [stateBtn, setStateBtn] = useState<boolean>(true);
  const [form] = Form.useForm();

  const handleOk = () => {
    setOpenModal(false);
  };

  const handleCancel = () => {
    setOpenModal(false);
    form.resetFields();
    setStateBtn(true);
  };

  const onSelect = (hrId: number) => {
    setStateBtn(false);
    if (vacationHrId === hrId) setStateBtn(true);
  };

  const onFinish = async (values: { hrId: number }) => {
    try {
      const { hrId } = values;
      const bodyRequest: TOvertimeTakeToWorkRequest = {
        hrId,
        overtimeId: requestId,
      };
      trigger(bodyRequest);
      form.resetFields();
      setStateBtn(true);
      notification.success({ message: 'Назначено на подчиненного' });
      setOpenModal(false);
    } catch (e: any) {
      notification.error({ message: returnErrorOrMessage(e, 'Что-то пошло не так') });
    }
  };

  return (
    <Modal
      title="Выберите ответственного сотрудника"
      footer={false}
      onOk={handleOk}
      onCancel={handleCancel}
      visible={openModal}
      destroyOnClose={true}
    >
      <Form form={form} name="rejectionForm" onFinish={onFinish}>
        <Form.Item
          name="hrId"
          rules={[
            {
              validator: async (_, v) => {
                if (v === vacationHrId) return Promise.reject();
              },
              message: 'Выберите нового ответственного',
            },
          ]}
        >
          <Select placeholder="Выберите из списка" onSelect={onSelect}>
            {[
              ...allSubordinates.filter(sub => sub.roleName === RolesToRussian[RolesUser.SecondLine]),
              ...allSubordinates.filter(sub => sub.roleName === RolesToRussian[RolesUser.FirstLine]),
              ...allSubordinates.filter(sub => sub.roleName === RolesToRussian[RolesUser.Consultant]),
              ...allSubordinates.filter(sub => sub.roleName === RolesToRussian[RolesUser.Employee]),
            ].map(({ id, name, middleName, lastName }) => (
              <Select.Option key={id} value={id}>
                {`${lastName} ${name} ${middleName ?? ''}`}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item>
          <Button htmlType="submit" type="primary" disabled={stateBtn}>
            Назначить
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ModalChangeResponsible;
